export default "__VITE_ASSET__UHktiCsO__"